module.exports = __webpack_public_path__ + "static/scale-model-of-columbia-convention-&-visitors-in-columbia-missouri-7b0ecc3ccb52f5c96d318761e1b98a1b.png";